/**
 * @generated SignedSource<<430cb4872fb23c9eadc43b49abe73d39>>
 * @relayHash 4d2418e9c9df72fed61f2d01e4d5b883
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3497617b2a9ab95e9ff662ecba81473084cda948b9dd74c1b2388909ad50a389

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PolarisGlobalViewsSettingsListPageQuery } from './PolarisGlobalViewsSettingsListPageQuery.graphql';

const node: PreloadableConcreteRequest<PolarisGlobalViewsSettingsListPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "3497617b2a9ab95e9ff662ecba81473084cda948b9dd74c1b2388909ad50a389",
    "metadata": {},
    "name": "PolarisGlobalViewsSettingsListPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
